import { type ContentCMS } from "@repo/common/src/types/firestore/cms/content";
import { CMSCollections } from "@repo/common/src/types/firestore/collections";
import { buildCollection, buildEntityCallbacks, buildProperty, type EntityOnSaveProps } from "@firecms/core";

import { Groups } from "./types";
import { standardPermissions } from "../utils/constants";
import { loadingOverlay } from "../utils/loadOverlay";

type ContentCMSModel = Omit<ContentCMS, "created_on" | "updated_on"> & {
  created_on: Date;
  updated_on: Date;
};

const callbacks = buildEntityCallbacks({
  onPreSave: async (props: EntityOnSaveProps<ContentCMSModel>) => {
    loadingOverlay.show();
    const { values } = props;
    return values;
  },
  onSaveSuccess: async () => {
    loadingOverlay.hide();
  },
  onSaveFailure: async () => {
    loadingOverlay.hide();
  },
});

export const content = buildCollection<ContentCMSModel>({
  id: CMSCollections.Content,
  name: "Rechtsinhalte App",
  singularName: "Rechtsinhalt App",
  description:
    "Rechtsinhalte für die App. Kann nur nach manueller freischaltung geändert werden, da Absprache mit Entwicklern notwendig ist.",
  path: CMSCollections.Content,
  icon: "Assignment",
  group: Groups.Other,
  permissions: () => {
    return standardPermissions;
  },
  subcollections: [],
  callbacks,
  properties: {
    title: {
      name: "Name",
      validation: { required: true },
      dataType: "string",
    },
    markdown: {
      name: "Beschreibung",
      dataType: "string",
      validation: { required: true },
      markdown: true,
    },
    created_on: buildProperty({
      name: "Erstellungsdatum",
      dataType: "date",
      autoValue: "on_create",
    }),
    updated_on: buildProperty({
      name: "Aktualisierungsdatum",
      dataType: "date",
      autoValue: "on_update",
    }),
  },
});
